import WithAuth from "../components/hoc/with-auth"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx"
import { Flex, Text, Box } from "@chakra-ui/react"
import ScamTradesPage from "../components/pages/scam-trades-pages.tsx"

const ScamTrades = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Scam Tades"
          pageDesc="List of all the most profitable trades"
        >
          <ScamTradesPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default ScamTrades
